import moment from "moment";
import { Tooltip } from "react-bootstrap";
import { LS_REDIRECT_URL_KEY, LS_RETURN_PARAMS_KEY } from "../constants/common";

export default class Utils {

  static decodeBase64(string) {
    return atob(string);
  }
  static encodeBase64(string) {
    return btoa(string);
  }

  static renderTooltip(text) {
    return <Tooltip>{text}</Tooltip>;
  }

  static isNotEmpty(val) {
    return val && val !== null && val !== '';
  }

  static getFormattedFormBuilderExitURL() {
    if (window.location.href.indexOf('/esgx/') >= 0) {
      return `${window.location.protocol}//${window.location.host}/esgx`;
    }
    const redirectURL = localStorage.getItem(LS_REDIRECT_URL_KEY);
    if (!redirectURL) return null;

    const returnParams = localStorage.getItem(LS_RETURN_PARAMS_KEY);
    if (!returnParams) return redirectURL;

    const paramObj = JSON.parse(returnParams);

    let url;
    if (redirectURL.indexOf('formbuilder') > 0) {
      url = redirectURL.split('/formbuilder')[0];
    } else {
      url = redirectURL;
    }
    if (paramObj.route) {
      url += `${paramObj.route}`;
    }
    if (paramObj.fid && paramObj.period) {
      url += `?fid=${paramObj.fid}&period=${paramObj.period}`;
    }
    if (paramObj.qParams) {
      const searchParams = new URLSearchParams(paramObj.qParams);
      const queryString = searchParams.toString();
      url += `?${queryString}`;
    }
    return url;
  }

  static getSectionAuditLogTooltip(submittedData) {
    return (
      <Tooltip>
        <div className="text-start">
          <div>
            <b>Last Modified by</b> :
            <div>
              {submittedData?.reporter ? `${submittedData?.reporter}, ` : ''}{submittedData?.branch?.name}
            </div>
          </div>
          <div>
            <b>Date</b> :
            <div>
              {moment(submittedData?.lastModifiedDate).format("MMM Do YYYY, h:mm a")}
            </div>
          </div>
        </div>
      </Tooltip>
    );
  }

  static getHelpTextPlaceHolder() {
    return `
      <p><b>Guidelines</b></p>
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>    
      <p>Lorem ipsum dolor sit amet</p>   
      <p>Lorem ipsum dolor sit amet</p>      
      <p><b>Potential Data Sources</b></p> 
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
      <p>Lorem ipsum dolor sit amet</p>
      <p>Lorem ipsum dolor sit amet</p>
      <p><b>Reference Links</b></p>
      <p>Lorem ipsum, Lorem ipsum</p>
    `;
  }

  static getBranchOrGroupDetailsToRender(form) {
    if (form?.formType === 'SURVEY') {
      return <div className='Department_Namebox'>{form?.stakeholderGroup?.name}</div>
    }
    if (form?.locationSpecific) {
      return (
        <div className='Department_Namebox'>
          <span>{form?.branch?.businessUnitType} : </span> {form?.branch?.name}
        </div>
      );
    }
    return <></>;

  };

  static convertMarkdownToHTML(inputString) {
    // Created using GPT 

    // Replace \n with <br> for line breaks
    let htmlString = inputString.replace(/\n/g, '<br>');

    // Convert markdown-style bold (**text**) to <strong>
    htmlString = htmlString.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');

    // Convert numbered lists (1. text) to <ol><li>text</li></ol>
    htmlString = htmlString.replace(/(\d+)\.\s(.*?)(?=<br>|$)/g, '<li>$2</li>');
    if (htmlString.includes('<li>')) {
      htmlString = '<ol>' + htmlString + '</ol>';
    }

    // Convert unordered list (- text) to <ul><li>text</li></ul>
    htmlString = htmlString.replace(/-\s(.*?)(?=<br>|$)/g, '<li>$1</li>');
    if (htmlString.includes('<li>')) {
      htmlString = htmlString.replace(/(<li>.*?<\/li>)/g, '<ul>$1</ul>');
    }

    // Remove nested <ul> or <ol> by flattening lists
    htmlString = htmlString.replace(/<\/ul><ul>/g, '');
    htmlString = htmlString.replace(/<\/ol><ol>/g, '');

    return htmlString;
  }

  static getHTMLMarkupFor = (content) => {
    return { __html: Utils.convertMarkdownToHTML(content) };
  };

  // Utility function to check if a file is an office document
  static isOfficeDocument = (fileName) => {
    if (!fileName) return false;
    const fileExtension = fileName.split('.').pop()?.toLowerCase();
    const officeExtensions = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'rtf'];
    return officeExtensions.includes(fileExtension);
  };

  static base64ToFile(base64String, filename, mimeType) {
    // 1. Decode the Base64 String
    // Function to convert base64 to Uint8Array
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    // 2. Create a Blob
    const blob = new Blob([byteArray], { type: mimeType });

    // 3. Create a File
    // The lastModified date can be taken from the createdDate or current time.
    const lastModified = new Date().getTime(); // or new Date(downloadApiResponse.createdDate).getTime();
    const file = new File([blob], filename, { type: mimeType, lastModified: lastModified });

    return file;
  }

  static isImageFile = (fileName) => {
    if (!fileName) return false;
    const fileExtension = fileName.split('.').pop()?.toLowerCase();
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'tif', 'tiff'];
    return imageExtensions.includes(fileExtension);
  };

  static isPdfFile = (fileName) => {
    if (!fileName) return false;
    const fileExtension = fileName.split('.').pop()?.toLowerCase();
    return fileExtension === 'pdf';
  };

  static isImageOrPdf = (fileName) => {
    return Utils.isImageFile(fileName) || Utils.isPdfFile(fileName);
  };

  /**
 * Converts an integer into its ordinal string (e.g., 1 -> "1st", 2 -> "2nd").
 *
 * @param {number} number The integer to convert.
 * @returns {string} The ordinal string representation.
 */
  static getOrdinalString(number) {
    // 1. Basic validation and handling of zero/non-integers
    if (typeof number !== 'number' || !Number.isInteger(number)) {
      throw new Error("Input must be an integer.");
    }
    if (number < 0) {
      throw new Error("Number must be non-negative.");
    }
    if (number === 0) {
      return "0";
    }

    // 2. Handle the exceptions: 11th, 12th, 13th (and 111th, 112th, etc.)
    // We check the last two digits (number % 100)
    if (number % 100 >= 11 && number % 100 <= 13) {
      return number + "th";
    }

    // 3. Determine the suffix based on the last digit
    // We check the last digit (number % 10)
    switch (number % 10) {
      case 1:
        return number + "st";
      case 2:
        return number + "nd";
      case 3:
        return number + "rd";
      default:
        return number + "th";
    }
  }
}
